export const GAME_NAME = 'Orbits';
export const BACKGROUND_COLOR = 'rgb(200,200,200)';
export const GAME_NAME_COLOR = 'mediumorchid';